import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useResourceById } from "@/hooks/resource-by-id.hook";
import { useResourceLibrary } from "@/hooks/resource-library.hook";
import { GetResponsesByQuizIdItemResource } from "@/requests/questionnaries/responses-by-quiz-id.request";
import { Book, Paperclip2 } from "iconsax-react";
import { FC } from "react";

type EvidenceListResourceItemProps = {
  evidenceResource: GetResponsesByQuizIdItemResource;
};

const EvidenceListResourceItem: FC<EvidenceListResourceItemProps> = ({
  evidenceResource,
}) => {
  const { data: userProfile } = useCurrentUserProfile();

  const { data: resourceLibrary } = useResourceLibrary();

  const { data: resource } = useResourceById({
    companyId: userProfile?.companyId || "",
    resourceLibraryId: resourceLibrary?.id || "",
    resourceId: evidenceResource.id,
  });

  if (!resource) {
    return null;
  }

  const href = resource.type === "LINK" ? resource.url : resource.signedUrl;

  return (
    <div className="flex items-start gap-2">
      <div className="flex items-center gap-2">
        {resource.type === "FILE" ? (
          <Book className="mt-0.5 inline-block" size={14} />
        ) : (
          <Paperclip2 className="mt-0.5 inline-block" size={14} />
        )}
      </div>
      <div>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="underline hover:text-black"
        >
          {evidenceResource.name}
        </a>
        <div>
          Páginas de referencia: {evidenceResource.reference || "Ninguna"}
        </div>
        <div>Comentario: {evidenceResource.comment || "Ninguno"}</div>
      </div>
    </div>
  );
};

export default EvidenceListResourceItem;
